"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = __importDefault(require("debug"));
var schema_1 = require("@staffbar/schema");
var frame_1 = __importDefault(require("./frame"));
var debug = (0, debug_1.default)("@staffbar/client:BarController");
/**
 * Bar controller which manages communications with the bar,
 * sets up the iframe.
 *
 */
var BarController = /** @class */ (function () {
    function BarController(messageHandler, options) {
        this.iFrameController = null;
        this._boundHandleMessage = this._handleMessage.bind(this);
        this.messageHandler = messageHandler;
        this.options = options;
    }
    /**
     * Setup the bar.
     *
     */
    BarController.prototype.setup = function () {
        this._setupListeners();
        // Setup the iframe
        this.iFrameController = new frame_1.default({
            url: this.options.url,
        });
        this.iFrameController.setup();
    };
    /**
     * Cleans up the bar.
     */
    BarController.prototype.cleanup = function () {
        var _a;
        (_a = this.iFrameController) === null || _a === void 0 ? void 0 : _a.cleanup();
        window.removeEventListener("message", this._boundHandleMessage);
    };
    /**
     * Message the bar.
     *
     * @param message A message (or array of messages) to send to the bar
     */
    BarController.prototype.publish = function (message) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var encoded;
            return __generator(this, function (_d) {
                debug("publish", message);
                encoded = schema_1.clientToBarEncoder.encode(message);
                (_c = (_b = (_a = this.iFrameController) === null || _a === void 0 ? void 0 : _a.iframeRef) === null || _b === void 0 ? void 0 : _b.contentWindow) === null || _c === void 0 ? void 0 : _c.postMessage(encoded, this.options.url);
                return [2 /*return*/];
            });
        });
    };
    BarController.prototype._setupListeners = function () {
        window.addEventListener("message", this._boundHandleMessage);
    };
    /**
     * Calls the message handler with the decoded messages
     *
     * @param event The raw message event
     * @returns void
     */
    BarController.prototype._handleMessage = function (event) {
        var _this = this;
        var _a;
        // Silence the react devtools messages from our logging
        if (event.data && ((_a = event.data["source"]) === null || _a === void 0 ? void 0 : _a.startsWith("react-devtools"))) {
            return;
        }
        debug("_handleMessage", event);
        // Only accept messages from the iframe
        if (event.origin !== this.options.url) {
            return;
        }
        // Parse the messages
        var messages = schema_1.barToClientEncoder.decode(event.data);
        messages.forEach(function (message) {
            var _a;
            // We'll handle the resize message ourselves
            if (message.type === "resize-iframe") {
                (_a = _this.iFrameController) === null || _a === void 0 ? void 0 : _a.resize(message.height);
                return;
            }
            _this.messageHandler(message);
        });
    };
    return BarController;
}());
exports.default = BarController;
